import { Flex, Grid, Label, Text } from '@approvalmax/ui/src/components';
import { FC, memo, useMemo } from 'react';

import { messages } from './QBooksCounterpartyDetails.messages';
import { Root } from './QBooksCounterpartyDetails.styles';
import { QBooksCounterpartyDetailsProps } from './QBooksCounterpartyDetails.types';

export const QBooksCounterpartyDetails: FC<QBooksCounterpartyDetailsProps> = memo((props) => {
    const { counterparty, hideAddress } = props;

    const billingAddress = useMemo(() => {
        const [billingAddress] = counterparty?.addresses || [];
        const address = billingAddress?.address;

        return [
            [address?.addressLine1, address?.addressLine2, address?.addressLine3, address?.addressLine4]
                .filter(Boolean)
                .join(', '),
            [address?.city, address?.region, address?.postalCode, address?.country].filter(Boolean).join(', '),
        ].filter(Boolean);
    }, [counterparty?.addresses]);

    if (!counterparty) return null;

    const { taxId, contactPersons } = counterparty;

    const emailAddress = contactPersons?.[0]?.emailAddress;

    return (
        <Root spacing='4 16'>
            {!hideAddress && billingAddress.length > 0 && (
                <Flex spacing='4' grow={1}>
                    <Label spacing='0'>{messages.address}</Label>

                    <Flex spacing='4 0' direction='column'>
                        {billingAddress.map((addressLine, index) => (
                            <Text key={index} font='label' fontSize='small'>
                                {addressLine}
                            </Text>
                        ))}
                    </Flex>
                </Flex>
            )}

            {(taxId || emailAddress) && (
                <Grid gridTemplateColumns='auto 1fr' columnGap={4}>
                    {taxId && (
                        <>
                            <Label>{messages.taxId}</Label>

                            <Text font='label' fontSize='small'>
                                {taxId}
                            </Text>
                        </>
                    )}

                    {emailAddress && (
                        <>
                            <Label>{messages.email}</Label>

                            <Text font='label' fontSize='small'>
                                {emailAddress}
                            </Text>
                        </>
                    )}
                </Grid>
            )}
        </Root>
    );
});

QBooksCounterpartyDetails.displayName = 'QBooksCounterpartyDetails';
